var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "refund-request-dialog",
      attrs: {
        fullscreen: true,
        "close-on-press-escape": false,
        "show-close": false,
        "close-on-click-modal": false,
        visible: _vm.visible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "refund-request-title-bar",
          attrs: { id: "refund-request-title" },
        },
        [
          !_vm.showFinalStep
            ? _c(
                "button",
                {
                  staticClass: "el-dialog__headerbtn",
                  staticStyle: { right: "unset", left: "20px" },
                  attrs: { type: "button", "aria-label": "Back" },
                  on: { click: _vm.back },
                },
                [
                  _c("i", {
                    staticClass: "el-dialog__close el-icon el-icon-arrow-left",
                  }),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "order-number" }, [
            _vm._v(
              "\n      Refund for order #" +
                _vm._s(
                  _vm.order.order.displayable_order_id ||
                    _vm.order.order.order_id
                ) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "el-dialog__headerbtn",
              attrs: { type: "button", "aria-label": "Close" },
              on: {
                click: function ($event) {
                  return _vm.$emit("update:visible", false)
                },
              },
            },
            [_c("i", { staticClass: "el-dialog__close el-icon el-icon-close" })]
          ),
          _vm._v(" "),
          _c("StepProgressBar", {
            attrs: {
              "total-steps": _vm.totalSteps,
              "current-step": _vm.currentStep,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "div",
            {
              staticClass: "refund-request-body",
              attrs: { id: "refund-request-body" },
            },
            [
              _c(
                "div",
                { staticClass: "refund-request-steps" },
                [
                  _vm.showInstallationWarning
                    ? _c(
                        "el-alert",
                        {
                          staticStyle: { "margin-bottom": "16px" },
                          attrs: {
                            title: "Installation Service — Do Not Refund",
                            type: "warning",
                            closable: false,
                            "show-icon": "",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "\n          Do not process refunds on the Installation ASIN (IG-5X-601-PIN).\n          Check your resources for guidance or reach out to leadership.\n        "
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("StepFlowButton", {
                    attrs: {
                      buttontext: "Step 1: Select Items",
                      isactive: _vm.isactive1,
                      "current-value": 1,
                      disabled: _vm.isdisabled1,
                    },
                    on: { "go-back": _vm.previous },
                  }),
                  _vm._v(" "),
                  _c("StepFlowButton", {
                    attrs: {
                      buttontext: "Step 2: Review & Confirm",
                      isactive: _vm.isactive2,
                      "current-value": 2,
                      disabled: _vm.isdisabled2,
                    },
                    on: { "go-back": _vm.previous },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticStyle: { border: "1px solid #DEE5EC" } }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "refund-request-data",
                  attrs: { id: "refund-request-data" },
                },
                [
                  _vm.currentStep === 1
                    ? _c("RefundSelectItems", {
                        attrs: {
                          loading: _vm.loading,
                          "refundable-items": _vm.refundableItems,
                          "shipping-total": _vm.shippingTotal,
                          "already-selected": _vm.allItemsWithAlreadySelected,
                          "refund-reasons": _vm.refundReasons,
                          "refund-shipping": _vm.refundShipping,
                        },
                        on: {
                          "update:loading": function ($event) {
                            _vm.loading = $event
                          },
                          "update:refundShipping": function ($event) {
                            _vm.refundShipping = $event
                          },
                          "update:refund-shipping": function ($event) {
                            _vm.refundShipping = $event
                          },
                          "get-selected-items-for-refund":
                            _vm.setSelectedItemsForRefund,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentStep === 2 && !_vm.showFinalStep
                    ? _c("ReviewRefundSummary", {
                        attrs: {
                          loading: _vm.loading,
                          customer: _vm.customerDetails,
                          "items-to-refund": _vm.selectedItems,
                          "shipping-total": _vm.shippingTotal,
                          "refund-shipping": _vm.refundShipping,
                        },
                        on: {
                          "update:loading": function ($event) {
                            _vm.loading = $event
                          },
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentStep === 2 && _vm.showFinalStep
                    ? _c("RefundSummary", {
                        attrs: {
                          loading: _vm.loading,
                          customer: _vm.customerDetails,
                          "items-to-refund": _vm.selectedItems,
                          "shipping-total": _vm.shippingTotal,
                          "refund-shipping": _vm.refundShipping,
                        },
                        on: {
                          "update:loading": function ($event) {
                            _vm.loading = $event
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "refund-request-footer",
          attrs: { id: "refund-request-footer" },
        },
        [
          _vm.showRefundSummaryConfirmationLink
            ? _c(
                "el-checkbox",
                {
                  staticClass: "confirm-checkbox",
                  staticStyle: { "margin-right": "24px" },
                  model: {
                    value: _vm.isSummaryConfirmed,
                    callback: function ($$v) {
                      _vm.isSummaryConfirmed = $$v
                    },
                    expression: "isSummaryConfirmed",
                  },
                },
                [_vm._v("\n      The items for refund are correct.\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showBack
            ? _c(
                "el-button",
                { staticClass: "action_button back", on: { click: _vm.back } },
                [_vm._v("\n      Back\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showNext
            ? _c(
                "el-button",
                {
                  staticClass: "action_button",
                  attrs: { type: "primary", disabled: _vm.isNextDisabled },
                  on: { click: _vm.next },
                },
                [_vm._v("\n      Next\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.currentStep == 2 && !_vm.showFinalStep
            ? _c(
                "el-button",
                {
                  staticClass: "action_button",
                  attrs: {
                    type: "primary",
                    disabled: _vm.isProcessRefundDisabled,
                  },
                  on: { click: _vm.processRefund },
                },
                [_vm._v("\n      Process Refund\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.currentStep == 2 && _vm.showFinalStep
            ? _c(
                "el-button",
                {
                  staticClass: "action_button",
                  attrs: { type: "primary" },
                  on: { click: _vm.exit },
                },
                [_vm._v("\n      Done\n    ")]
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }